export default __webpack_public_path__ + "static/media/logo_alsa.d13ee3ff.svg";